import { TableUIProvider } from "../../contexts/TableUIContext";
import Courses from "./Courses";

export default function CoursesWrapper() {
    return (
        <TableUIProvider>
            <Courses />
        </TableUIProvider>
    );
}
